import React from 'react'

import { ColumnProps } from 'antd/lib/table'

import { OverReimbursementItem } from 'core/application/adminDashboard/reimbursements/overReimbursements/getOverReimbursements'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { formatMoney } from 'common/moneyFormatter'

export const overReimbursementsColumns = (
  translate: (key: string) => string,
  filter: OrderedPageFilter,
): ColumnProps<OverReimbursementItem>[] => {
  const columns: ColumnProps<OverReimbursementItem>[] = [
    {
      title: translate('admin-dashboard.reimbursements.over-reimbursements.full-name-label'),
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'left',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-over-reimbursements-full-name',
    },
    {
      title: translate('admin-dashboard.reimbursements.over-reimbursements.allowance-ytd-label'),
      dataIndex: 'allowanceYTD',
      key: 'allowanceYTD',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-over-reimbursements-allowance-ytd',
    },
    {
      title: translate('admin-dashboard.reimbursements.over-reimbursements.expense-ytd-label'),
      dataIndex: 'expenseYTD',
      key: 'expenseYTD',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-over-reimbursements-expenses-ytd',
    },
    {
      title: translate('admin-dashboard.reimbursements.over-reimbursements.reimbursement-ytd-label'),
      dataIndex: 'reimbursementYTD',
      key: 'reimbursementYTD',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-over-reimbursements-reimbursement-ytd',
    },
    {
      title: translate('admin-dashboard.reimbursements.over-reimbursements.over-reimbursed-label'),
      dataIndex: 'overReimbursed',
      key: 'overReimbursed',
      align: 'right',
      render: (item: number) => {
        return <label className="over_reimbursed_value">({formatMoney(item)})</label>
      },
      className: 't-over-reimbursements-over-reimbursed-ytd',
    },
  ]

  const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
  columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

  return columns
}
